import React from "react";
import { Button } from "react-bootstrap";
import "./Pink_Btn.css";

const Pink_Btn = ({ btnText, onClick, className = "" }) => {
  return (
    <section className="Pink_Btn_holder">
      <Button
        className={`Pink_Btn ${className}`}
        onClick={onClick}
      >
        {btnText}
      </Button>
    </section>
  );
};

export default Pink_Btn;
